/* ==========================================================================
  KENO GAME CONSTANTS
========================================================================== */
export const KENO_RISK_MODES = {
  CLASSIC: 'CLASSIC',
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH'
}

export const KENO_GAME_RISK_LEVEL = [
  {
    label: 'Classic',
    value: 1
  },
  {
    label: 'Low',
    value: 2
  },
  {
    label: 'Medium',
    value: 3
  },
  {
    label: 'High',
    value: 4
  }
]

export const KENO_PAYOUTS_OLD = {
  0: { 0: 0 },
  1: { 0: 0, 1: 3.8 },
  2: { 0: 0, 1: 1, 2: 9.5 },
  3: { 0: 0, 1: 1, 2: 2, 3: 18 },
  4: { 0: 0, 1: 0.5, 2: 1.5, 3: 8, 4: 20 },
  5: { 0: 0, 1: 0.5, 2: 1, 3: 3, 4: 16, 5: 50 },
  6: { 0: 0, 1: 0.5, 2: 1, 3: 2, 4: 4, 5: 24, 6: 70 },
  7: { 0: 0, 1: 0.5, 2: 0.5, 3: 1, 4: 5, 5: 16, 6: 50, 7: 250 },
  8: { 0: 0, 1: 0.5, 2: 0.5, 3: 1, 4: 3, 5: 7, 6: 20, 7: 80, 8: 750 },
  9: { 0: 0, 1: 0.5, 2: 0.5, 3: 1, 4: 2, 5: 4, 6: 10, 7: 25, 8: 60, 9: 1250 },
  10: { 0: 0, 1: 0, 2: 0.5, 3: 1, 4: 2, 5: 3, 6: 5, 7: 10, 8: 20, 9: 200, 10: 1600 },
  11: { 0: 0, 1: 0, 2: 0.5, 3: 1, 4: 1, 5: 2.5, 6: 5, 7: 8, 8: 16, 9: 150, 10: 100, 11: 2500 },
  12: { 0: 0, 1: 0, 2: 0, 3: 1, 4: 1, 5: 2, 6: 4, 7: 7, 8: 30, 9: 200, 10: 800, 11: 1500, 12: 4000 },
  13: { 0: 0, 1: 0, 2: 0, 3: 0.5, 4: 1, 5: 2, 6: 4, 7: 6, 8: 10, 9: 60, 10: 150, 11: 500, 12: 3000, 13: 6000 },
  14: { 0: 0, 1: 0, 2: 0, 3: 0.5, 4: 0.5, 5: 2, 6: 3, 7: 5, 8: 8, 9: 40, 10: 120, 11: 400, 12: 1000, 13: 4000, 14: 8000 },
  15: { 0: 0, 1: 0, 2: 0, 3: 0.5, 4: 0.5, 5: 1.5, 6: 2, 7: 4, 8: 7, 9: 25, 10: 80, 11: 250, 12: 500, 13: 1000, 14: 2500, 15: 10000 },
  16: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0.5, 5: 0.5, 6: 1, 7: 4, 8: 17, 9: 70, 10: 150, 11: 400, 12: 1000, 13: 2000, 14: 5000, 15: 8000, 16: 12000 },
  17: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0.5, 6: 1.5, 7: 4, 8: 9, 9: 40, 10: 90, 11: 200, 12: 400, 13: 800, 14: 2000, 15: 7000, 16: 10000, 17: 14000 },
  18: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0.5, 6: 1.5, 7: 4, 8: 7, 9: 10, 10: 30, 11: 60, 12: 200, 13: 400, 14: 700, 15: 2000, 16: 8000, 17: 11000, 18: 16000 },
  19: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 1, 6: 1.5, 7: 2, 8: 2, 9: 9, 10: 30, 11: 60, 12: 90, 13: 250, 14: 300, 15: 600, 16: 2500, 17: 9000, 18: 12000, 19: 18000 },
  20: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 1, 6: 1, 7: 2.5, 8: 2.5, 9: 3, 10: 10, 11: 40, 12: 90, 13: 150, 14: 200, 15: 400, 16: 700, 17: 3000, 18: 10000, 19: 14000, 20: 20000 }
}

export const KENO_PAYOUTS = {
  0: {
    CLASSIC: [0],
    LOW: [0],
    MEDIUM: [0],
    HIGH: [0]
  },
  1: {
    CLASSIC: [0, 3.96],
    LOW: [0.7, 1.85],
    MEDIUM: [0.4, 2.75],
    HIGH: [0, 3.96]
  },
  2: {
    CLASSIC: [0, 1.9, 4.5],
    LOW: [0, 2, 3.8],
    MEDIUM: [0, 1.8, 5.1],
    HIGH: [0, 0, 17.1]
  },
  3: {
    CLASSIC: [0, 1, 3.1, 10.4],
    LOW: [0, 1.1, 1.38, 26],
    MEDIUM: [0, 0, 2.8, 50],
    HIGH: [0, 0, 0, 81.5]
  },
  4: {
    CLASSIC: [0, 0.8, 1.8, 5, 22.5],
    LOW: [0, 0, 2.2, 7.9, 90],
    MEDIUM: [0, 0, 1.7, 10, 100],
    HIGH: [0, 0, 0, 10, 259]
  },
  5: {
    CLASSIC: [0, 0.25, 1.4, 4.1, 16.5, 36],
    LOW: [0, 0, 1.5, 4.2, 13, 300],
    MEDIUM: [0, 0, 1.4, 4, 14, 390],
    HIGH: [0, 0, 0, 4.5, 48, 450]
  },
  6: {
    CLASSIC: [0, 0, 1, 3.68, 7, 16.5, 40],
    LOW: [0, 0, 1.1, 2, 6.2, 100, 700],
    MEDIUM: [0, 0, 0, 3, 9, 180, 710],
    HIGH: [0, 0, 0, 0, 11, 350, 710]
  },
  7: {
    CLASSIC: [0, 0, 0.47, 3, 4.5, 14, 31, 60],
    LOW: [0, 0, 1.1, 1.6, 3.5, 15, 225, 700],
    MEDIUM: [0, 0, 0, 2, 7, 30, 400, 800],
    HIGH: [0, 0, 0, 0, 7, 90, 400, 800]
  },
  8: {
    CLASSIC: [0, 0, 0, 2.2, 4, 13, 22, 55, 70],
    LOW: [0, 0, 1.1, 1.5, 2, 5.5, 39, 100, 800],
    MEDIUM: [0, 0, 0, 2, 4, 11, 67, 400, 900],
    HIGH: [0, 0, 0, 0, 5, 20, 270, 600, 900]
  },
  9: {
    CLASSIC: [0, 0, 0, 1.55, 3, 8, 15, 44, 60, 85],
    LOW: [0, 0, 1.1, 1.3, 1.7, 2.5, 7.5, 50, 25, 1000],
    MEDIUM: [0, 0, 0, 2, 2.5, 5, 15, 100, 500, 1000],
    HIGH: [0, 0, 0, 0, 4, 11, 56, 500, 800, 1000]
  },
  10: {
    CLASSIC: [0, 0, 0, 1.4, 2.25, 4.5, 8, 17, 50, 80, 100],
    LOW: [0, 0, 1.1, 1.2, 1.3, 1.8, 3.5, 13, 50, 250, 1000],
    MEDIUM: [0, 0, 0, 1.6, 2, 4, 7, 26, 100, 500, 1000],
    HIGH: [0, 0, 0, 0, 3.5, 8, 13, 63, 500, 800, 1000]
  }
}

export const BET_MODES = {
  MANUAL: 'manual',
  AUTO: 'auto',
  STRATEGY: 'strategy'
}

export const MAX_INCREASED_BY_PERCENTAGE = {
  KENO_AUTO_BET: 100
}

export const WALLET_EMIT_TYPES = {
  CREDIT: 'credit',
  DEBIT: 'debit',
  RESOLVE: 'resolve',
  DEFAULT: 'default'
}

export const DEFAULT_PAGE_CALLS = 20
export const ANIMATION_TIMEOUT_IN_MS = 150
